import ReactDOM from "react-dom";
import React from "react";

import { DataProvider } from "./helpers/DataProvider.jsx";

import Listing from "./apps/Listing.jsx";
import ListingAlt from "./apps/ListingAlt.jsx";
import Search from "./apps/Search.jsx";

export const listingInit = (mountNode, id) => {
  const config = window.nberListingConfigs.find(config => { return config.id == id });

  // console.log(config);
  
  switch (config.type) {
    case "listing":
      ReactDOM.render(
        <DataProvider
          id={ id }
          url={ config.api }
          config={ config }
          render={ ({ data, loading, updateParams }) => <Listing config={ config } data={ data } handleUpdate={ updateParams } loading={ loading } /> } />,
        mountNode
      );
      break;
    case "listing_alt":
      ReactDOM.render(
        <DataProvider
          id={ id }
          url={ config.api }
          config={ config }
          render={ ({ data, loading, updateParams }) => <ListingAlt config={ config } data={ data } handleUpdate={ updateParams } loading={ loading } /> } />,
        mountNode
      );
      break;
    default:
      ReactDOM.render(
        <DataProvider
          id={ id }
          url={ config.api }
          config={ config }
          render={ ({ data, loading, updateParams }) => <Search config={ config } data={ data } handleUpdate={ updateParams } loading={ loading } /> } />,
        mountNode
      );
  }
}
